import { render, staticRenderFns } from "./AnimalTypeSection.vue?vue&type=template&id=75f9bcee&"
import script from "./AnimalTypeSection.vue?vue&type=script&lang=js&"
export * from "./AnimalTypeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports